export const YOUR_DOMAIN = "project.creation.list.item.your.domain";
